"use client";

import { c as _c } from "react/compiler-runtime";
import { clsx as cn } from "@/helpers/clsx";
import { Input, labelVariants } from "@openapi/ui/components/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@openapi/ui/components/select";
import { type SelectedServer, useApiContext } from "@openapi/ui/contexts/api";
import type { HTMLAttributes } from "react";
export default function ServerSelect(t0) {
  const $ = _c(14);
  const {
    server,
    onServerChanged,
    onVariablesChanged,
    ...props
  } = t0;
  const {
    servers
  } = useApiContext();
  if (servers.length <= 1) {
    return null;
  }
  const schema = server ? servers.find(item => item.url === server.url) : null;
  const t1 = cn("flex flex-col gap-4", props.className);
  const t2 = server?.url;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SelectTrigger className="break-all"><SelectValue /></SelectTrigger>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== servers) {
    t4 = servers.map(_temp);
    $[1] = servers;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t4) {
    t5 = <SelectContent>{t4}</SelectContent>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onServerChanged || $[6] !== t2 || $[7] !== t5) {
    t6 = <Select value={t2} onValueChange={onServerChanged}>{t3}{t5}</Select>;
    $[5] = onServerChanged;
    $[6] = t2;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t8 = Object.entries(schema?.variables ?? {}).map(t7 => {
    const [key, variable] = t7;
    if (!server) {
      return;
    }
    const id = `fd_server_select_${key}`;
    return <fieldset key={key} className="flex flex-col gap-1"><label className={cn(labelVariants())} htmlFor={id}>{key}</label><p className="text-xs text-fd-muted-foreground empty:hidden">{variable.description}</p>{variable.enum ? <Select value={server.variables[key]} onValueChange={v => onVariablesChanged({
        ...server?.variables,
        [key]: v
      })}><SelectTrigger id={id}><SelectValue /></SelectTrigger><SelectContent>{variable.enum.map(_temp2)}</SelectContent></Select> : <Input id={id} value={server.variables[key]} onChange={e => onVariablesChanged({
        ...server?.variables,
        [key]: e.target.value
      })} />}</fieldset>;
  });
  let t9;
  if ($[9] !== props || $[10] !== t1 || $[11] !== t6 || $[12] !== t8) {
    t9 = <div {...props} className={t1}>{t6}{t8}</div>;
    $[9] = props;
    $[10] = t1;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
}
function _temp2(value) {
  return <SelectItem key={value} value={value}>{value}</SelectItem>;
}
function _temp(item_0) {
  return <SelectItem key={item_0.url} value={item_0.url}>{item_0.url}<p className="text-start text-fd-muted-foreground">{item_0.description}</p></SelectItem>;
}